import { render, staticRenderFns } from "./MMP_LoadingScreen.vue?vue&type=template&id=6368a636&scoped=true&"
import script from "./MMP_LoadingScreen.vue?vue&type=script&lang=js&"
export * from "./MMP_LoadingScreen.vue?vue&type=script&lang=js&"
import style0 from "./MMP_LoadingScreen.vue?vue&type=style&index=0&id=6368a636&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368a636",
  null
  
)

export default component.exports